/**
 * #1074 — dónde viven de verdad los textos legales.
 *
 * MEDIDO EN PRODUCCIÓN el 2026-08-17, con control:
 *
 *   https://inbomarket.com/legal/privacidad        200  "Política de Privacidad | InboMarket"
 *   https://inbomarket.com/legal/terminos          200  "Términos del Servicio | InboMarket"
 *   https://inbomarket.com/legal/no-existe-tina    404  <- control: acá un 404 es un 404
 *
 * Y lo que había enlazado en el dashboard NO servía ninguno de esos textos.
 * Tres rutas distintas, ninguna correcta:
 *
 *   /docs/legal/terms              (LegalConsentModal, #1112 — lo puse yo)
 *   /docs/legal/privacy-policy     (LegalConsentModal y Step1Account)
 *   /docs/legal/terms-of-service   (Step1Account)
 *
 * POR QUÉ NO SE VEÍA: el dashboard es una SPA con catch-all. `/docs/legal/loquesea`
 * devuelve **200 con el index**, así que el enlace "abre" y muestra la app en vez
 * del documento. Un 200 acá no prueba que el documento exista — lo confirmé
 * pidiendo una ruta inventada y recibiendo 200 igual. En el host de marketing,
 * donde un 404 sí es 404, las tres dan 404.
 *
 * POR QUÉ IMPORTA MÁS QUE UN ENLACE ROTO: el modal de #1112 le pide al usuario
 * que acepte dos documentos, y guarda esa aceptación con su fecha y su versión
 * como prueba ante la Ley 172-13. Si el enlace devuelve la app en vez del texto,
 * el usuario acepta algo que nunca leyó: la prueba queda más débil que no tener
 * nada, porque parece cumplimiento y no lo es. El consent screen de Google marca
 * exactamente lo mismo (#1074).
 *
 * SON ABSOLUTAS A PROPÓSITO: el dashboard vive en app.inbomarket.com y los
 * textos en inbomarket.com. Una ruta relativa se la come el catch-all de la SPA,
 * que es justo el defecto que esto corrige.
 */
const BASE_LEGAL = import.meta.env.VITE_LEGAL_BASE_URL || 'https://inbomarket.com';

export const LEGAL_LINKS = {
  terminos: `${BASE_LEGAL}/legal/terminos`,
  privacidad: `${BASE_LEGAL}/legal/privacidad`,
  terminosComprador: `${BASE_LEGAL}/legal/terminos-comprador`,
  cookies: `${BASE_LEGAL}/legal/cookies`,
  // GH#3082: la casilla de «Confirma tu plan» acepta el Acuerdo de Procesamiento de Datos y no lo enlazaba.
  // Medido en producción el 2026-10-20: https://inbomarket.com/legal/dpa 200 «Acuerdo de Procesamiento de Datos
  // (DPA) | InboMarket»; control /legal/no-existe-muse-3082 404.
  dpa: `${BASE_LEGAL}/legal/dpa`,
} as const;
